// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blockHeader[data-v-2c95a42f]{width:100%;height:3.021vw;position:relative}.blockHeader .redBlock[data-v-2c95a42f]{height:.938vw;width:.208vw;position:absolute;background-color:#e96b5a;top:.99vw;left:1.042vw}.blockHeader .headerText[data-v-2c95a42f]{height:.833vw;line-height:.833vw;color:#222;display:inline-block;position:absolute;top:1.094vw;left:1.771vw;font-weight:600}.listContain[data-v-2c95a42f]{width:98.5%;margin:0 auto}", ""]);
// Exports
module.exports = exports;
